import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
   Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
} from "@mui/material";
import styles from "../../../styles.module.css";
import CloseIcon from "@mui/icons-material/Close";
import sales_order from "../../../services/sales_order";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  dateConversion,
} from "../../reusableComponent/Reusables";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import CustomPagination from "../../reusableComponent/CustomPagination";

const Listsalseorder = () => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const defaultRowsPerPage = useSelector((state) => state.sales_order?.rows_per_page || 15);
  const [total_count, setTotalCount] = useState(0);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage,
  });
  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);
  const [sortBy, setSortBy] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [successMessage, setSuccessMessage] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);

  useEffect(() => {
    setTotalCount(rows[0]?.totalCount || 0);
  }, [rows]);

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };
      const response = await sales_order.getsalesorder(params);
      setRows(response);
    } catch (error) {
      setSuccessMessage("Error fetching data");
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller, searchKey]);

  useEffect(() => {
    setController((prev) => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setController((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setController({ page: 0, rowsPerPage: parseInt(event.target.value, 10) });
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchValue);
    const params = {
      page: controller.page,
      size: searchValue === "" ? controller.rowsPerPage : rows[0]?.total_count || 0,
      searchKey: searchValue,
    };
    try {
      await fetchData(params);
    } catch (error) {
      console.error("Error in handleSearch:", error);
    }
  };

  const HandleSort = (field) => {
    const newSortBy = sortBy === field ? null : field;
    setSortBy(newSortBy);
    if (newSortBy) {
      setRows((prevRows) =>
        [...prevRows].sort((a, b) => {
          if (a[newSortBy] < b[newSortBy]) return -1;
          if (a[newSortBy] > b[newSortBy]) return 1;
          return 0;
        })
      );
    } else {
      fetchData();
    }
  };

  const handleDelete = (row) => {
    setIsDelete(true);
    setDeleteInfo(row);
  };

  const deleteRecord = async (id) => {
    try {
      await sales_order.editDeletesalesorder({
        sales_order_id: id,
        changedUpdatedValue: "delete",
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleClose = () => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  // Handle row click to open dialog and set selected row and cylinder details
  const handleRowClick = (row) => {
    setSelectedRow(row);
    try {
      const cylinderDetails = JSON.parse(row.table_details);
      setSelectedCylinderDetails(cylinderDetails);
    } catch (error) {
      console.error("Error parsing table_details:", error);
      setSelectedCylinderDetails([]);
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setSelectedCylinderDetails([]);
  };

  const fields = ["customer_name", "po_no", "sales_officer_name"];
  const labels = ["Customer name", "PO NO", "Sales Officer Name"];
  const sortedRows = [...rows].sort((a, b) => new Date(b.so_date) - new Date(a.so_date));
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;

  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: "0px !important", margin: "0px !important" }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: "Sales Order List" }]} />

        <HeaderSection
          title="SALES ORDER"
          addNewPath="/salesEntries/add-so"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="Sales order"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
          View_Pending_Order="/storeEntries/Pending_Sales_Order"
          stocks=""
        />

        <Paper sx={{ width: "100%" }}>
          <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell
  align="left"
  className={styles.table_head}


>
  SO NO
</StyledTableCell>
                  <StyledTableCell
                    align="left"
                    className={styles.table_head}
      
                  >
                    SO Date
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    className={styles.table_head}
                   
                  >
                    Customer Name
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    className={styles.table_head}
                 
                  >
                    PO NO
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    className={styles.table_head}
                 
                  >
                    Sales Officer Name
                  </StyledTableCell>
                  <StyledTableCell align="center" className={styles.table_head}>
                    Action
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
           <TableBody sx={{ backgroundColor: "#fff" }}>
  {Array.isArray(rows) &&
    rows.map((row) => (
      <StyledTableRow
        key={row.sales_order_id}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
       <StyledTableCell
  align="left"
  className={`${styles.list_table_body}`}
  onClick={() => handleRowClick(row)}
>
  <Typography
    sx={{ fontSize: "12px", fontWeight: "bold", cursor: "pointer", color: "#1976d2", textDecoration: "underline" }}
  >
    {row.so_no}
  </Typography>
</StyledTableCell>
        <StyledTableCell align="left" className={`${styles.list_table_body}`}>
          {dateConversion(row?.so_date)}
        </StyledTableCell>
        <StyledTableCell align="left" className={`${styles.list_table_body}`}>
          {row.customer_name}
        </StyledTableCell>
        <StyledTableCell align="center" className={`${styles.list_table_body}`}>
          {row.po_no}
        </StyledTableCell>
        <StyledTableCell align="left" className={`${styles.list_table_body}`}>
          {row.sales_officer_name}
        </StyledTableCell>
        <StyledTableCell align="center">
          <CustomePopover
            row={row}
            handleDelete={false}
            linkTo="/salesEntries/add-so"
            showEdit={false}
              handleCancel={false}
              handlePrint={false}
          />
        </StyledTableCell>
      </StyledTableRow>
    ))}
</TableBody>
            </Table>
          </TableContainer>
                    <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>
        </Paper>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth={false}
          sx={{
            "& .MuiDialog-paper": {
              margin: "auto",
              width: "92vw",
              maxHeight: "85vh",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              overflow: "hidden",
              fontFamily: "'Inter', Arial, sans-serif",
             
            },
          }}
        >
          {/* ── Dialog Header (Navy) ── */}
          <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.5px", fontFamily: "'Inter', Arial, sans-serif" }}>
              SALES ORDER DETAILS
            </Typography>
            <IconButton onClick={handleCloseDialog} sx={{ color: "#fff", p: 0.5 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{ padding: "20px 24px", background: "#F4F7FB", overflowY: "auto" }}>

            {/* ── Order Information Card ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0",  overflow: "hidden", mb: 2.5 }}>

              {/* Card Header */}
              <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
                  📋  Order Information
                </Typography>
              </Box>

              {/* Caption Grid */}
              <Box>
                <Grid container>

                  {/* Row 1 */}
                  <Grid item xs={12} sm={6} md={2} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      SO No
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1C3A5E", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {selectedRow?.so_no || "—"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={2} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      SO Date
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {dateConversion(selectedRow?.so_date) || "—"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={2} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      PO No
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {selectedRow?.po_no || "—"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={2} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      PO Date
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {dateConversion(selectedRow?.po_date) || "—"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={2} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      Customer Name
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {selectedRow?.customer_name || "—"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={2} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      Sales Officer
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {selectedRow?.sales_officer_name || "—"}
                    </Typography>
                  </Grid>

                </Grid>
              </Box>
            </Box>

            {/* ── Product Details Table ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden" }}>

              {/* Table Header */}
              {/* <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
                  📦  Product Details
                </Typography>
              </Box> */}

              <TableContainer sx={{ maxHeight: "320px" }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                      {[
                        "Sr No", "Product Code", "Product Description",
                        "PO Qty (kg)", "Delivery Qty (kg)", "Balance Qty (kg)",
                        "Plan Qty (kg)", "Current Holding"
                      ].map((header) => (
                        <StyledTableCell
                          key={header}
                          align="center"
                          sx={{
                            backgroundColor: "#1C3A5E !important",
                            color: "#fff !important",
                            fontFamily: "'Inter', Arial, sans-serif",
                            fontWeight: 700,
                            fontSize: "12px",
                            padding: "10px 12px",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid rgba(255,255,255,0.1)",
                          }}
                        >
                          {header}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {selectedCylinderDetails.length > 0 ? (
                      selectedCylinderDetails.map((row, index) => (
                        <StyledTableRow
                          key={index}
                          sx={{
                            backgroundColor: index % 2 === 0 ? "#fff" : "#F8FAFC",
                            "&:hover": { backgroundColor: "#EBF4FF" },
                          }}
                        >
                          {[
                            row.srno || index + 1,
                            row.prod_code || "—",
                            row.prod_description || "—",
                            row.qty_kg || "—",
                            row.Del_qty || "—",
                            row.bal_qty || "—",
                            row.plan_qty || "—",
                            row.curr_hold || "—",
                          ].map((val, ci) => (
                            <StyledTableCell
                              key={ci}
                              align="center"
                              sx={{
                                fontSize: "12px",
                                fontFamily: "'Inter', Arial, sans-serif",
                                color: "#2D3748",
                                padding: "8px 12px",
                                borderBottom: "1px solid #EDF2F7",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val}
                            </StyledTableCell>
                          ))}
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell
                          colSpan={8}
                          align="center"
                          sx={{ py: 5, fontSize: "13px", color: "#A0AEC0", fontFamily: "'Inter', Arial, sans-serif" }}
                        >
                          No product details available
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

          </DialogContent>

          {/* ── Dialog Footer ── */}
          <Box sx={{ padding: "12px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={handleCloseDialog}
              sx={{
                background: "#E53E3E",
                color: "#fff",
                fontSize: "13px",
                fontWeight: 600,
                textTransform: "none",
                padding: "7px 20px",
                borderRadius: "8px",
                fontFamily: "'Inter', Arial, sans-serif",
                "&:hover": { background: "#971f16" },
              }}
            >
              Close
            </Button>
          </Box>
        </Dialog>

        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.sales_order_id || null}
          displayName={deleteInfo?.sales_order_id || ""}
        />

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== "clickaway") {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default Listsalseorder;